<md-toolbar
  class="top"
  color="primary"
  [ngClass]="envName.toLowerCase()"
  (window:resize)="onResize()"
>
  <md-icon
    *ngIf="currentUser"
    class="menu-icon"
    (click)="sidenavService.open()"
  >
    menu
  </md-icon>
  <div class="logo" routerLink="/"></div>
  <div class="logoName">Taiga</div>
  <div>{{ sidenavService.currentTab }}</div>
  <div *ngIf="currentUser" class="header-message">{{ headerMessage }}</div>
  <div class="spacer"></div>
  <div class="user" *ngIf="currentUser">
    <button
      id="help-icon"
      md-icon-button
      (click)="showTooltip()"
      md-tooltip="Click here for help"
    >
      <md-icon id="help-icon">help_outline</md-icon>
    </button>
    <div *ngIf="tooltipShow" class="overlay" id="overlay"></div>
    <div id="help-tooltip" class="help-tooltip">
      <div id="help-tooltip">
        <a
          class="help-link"
          href="https://wbd.service-now.com/serviceportal?id=sc_cat_item&sys_id=0efc5ae21be3e550c59543b1b24bcb60"
          target="_blank"
          >Contact Support</a
        >
        <br />
        For userguide, please
        <a class="help-link" href="assets/Userguide.pdf" target="_blank"
          >download here</a
        >
        <br />
      </div>
    </div>
    <md-select
      [(ngModel)]="currentUser.currentLanguage"
      (change)="changeLanguage($event)"
      md-tooltip="Select your language"
    >
      <md-option
        *ngFor="
          let language of currentUser.languages
            | searchByTerm : languageSearch : ['value']
            | orderBy : 'value'
        "
        [value]="language"
      >
        {{ language.value }}
      </md-option>
    </md-select>
    <div class="timezone">
      <md-icon>access_time</md-icon>
      {{ currentUser.currentLanguage.timeZone }}
    </div>
    <div
      *ngIf="!currentUser.currentLanguage.isDefault"
      class="change-default"
      (click)="changeDefaultLanguage()"
      md-tooltip="Click to set this language as your default language"
    >
      <md-icon>change_circle</md-icon> Change
    </div>
    <div class="username" color="primary" [ngClass]="envName.toLowerCase()">
      <md-icon>account_circle</md-icon>
      <div *ngIf="currentUser.firstName || currentUser.lastName">
        {{ currentUser.firstName }} {{ currentUser.cleanedLastName }}
      </div>
      <div *ngIf="!currentUser.firstName && !currentUser.lastName">
        {{ currentUser.login }}
      </div>
      <md-icon class="logout" (click)="logout()" md-tooltip="Logout"
        >close</md-icon
      >
    </div>
  </div>
</md-toolbar>



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.html